import React from 'react'
import { Dashboard } from '../../containers'

const DashboardMain = () => {
  return <Dashboard />
}

export default DashboardMain
